import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

export const BrowserTransferIcon = (props: SVGProps): JSX.Element => {
  return <SpriteIcon spriteId="transferbrowser" {...props} />;
};
